// store/modules/disposals/actions.js
import DisposalApi from "../../../api/modules/DisposalApi";

const searchDisposals = (_, payload) => {
  return DisposalApi.searchDisposals(payload.context, payload);
};

const getDisposalById = (_, payload) => {
  return DisposalApi.getDisposalById(payload.context, payload.id);
};

const getDisposalDetail = (_, payload) => {
  return DisposalApi.getDisposalDetail(payload.context, payload);
};

const changeStatusDisposal = (_, payload) => {
  return DisposalApi.changeStatusDisposal(payload.context, payload.idDisposal, payload.request);
};

const exportDisposalsExcel = (_, payload) => {
  return DisposalApi.exportDisposalsExcel(payload.context, payload.filters);
};

const exportDisposalsPdf = (_, payload) => {
  return DisposalApi.exportDisposalsPdf(payload.context, payload.filters);
};

const prepareExportDisposalOrderPdf = (_, payload) => {
  return DisposalApi.prepareExportDisposalOrderPdf(payload.context, payload.disposalId);
};

const exportDisposalOrderPdf = (_, payload) => {
  return DisposalApi.exportDisposalOrderPdf(payload.context, payload.disposalId);
};

export default {
  searchDisposals,
  getDisposalById,
  getDisposalDetail,
  changeStatusDisposal,
  exportDisposalsExcel,
  exportDisposalsPdf,
  prepareExportDisposalOrderPdf,
  exportDisposalOrderPdf
};



// WEBPACK FOOTER //
// ./src/store/modules/disposals/actions.js